<div class="content__inner">
    <header class="content__title">
        <h1 *ngIf="MODE === 'VIEW'">{{ "abousers.detail.view.title" | translate }}</h1>

        <div class="actions">
            <button (click)="back()" class="btn btn-secondary btn--icon-text"><i class="zmdi zmdi-arrow-back"></i> {{ "global.buttons.back" | translate }}</button>
        </div>
    </header>

    <div class="card">
        <div class="card-body" *ngIf="aboUser && aboUser.userAboInfo">
            <h3 class="card-body__title">{{ "abousers.props.userinfo" | translate }}</h3>
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "abousers.props.firstname" | translate }}</label>
                        <input name="firstname" type="text" class="form-control" [ngModel]="aboUser.firstname" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "abousers.props.lastname" | translate }}</label>
                        <input name="lastname" type="text" class="form-control" [ngModel]="aboUser.lastname" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "abousers.props.email" | translate }}</label>
                        <input name="email" type="text" class="form-control" [ngModel]="aboUser.email" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "abousers.props.availableQuota" | translate }}</label>
                        <input name="availableQuota" type="text" class="form-control" [ngModel]="aboUser.userAboInfo.availableQuota" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "abousers.props.usedQuota" | translate }}</label>
                        <input name="usedQuota" type="text" class="form-control" [ngModel]="aboUser.userAboInfo.usedQuota" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "abousers.props.camMaySendHighRes" | translate }}</label>
                        <div class="row">
                            <div class="col-12">
                                <div class="toggle-switch">
                                    <input type="checkbox" class="toggle-switch__checkbox" [ngModel]="aboUser.userAboInfo.camMaySendHighRes" id="camMaySendHighRes" name="camMaySendHighRes" [disabled]="true" />
                                    <i class="toggle-switch__helper"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card">
        <div class="card-body" *ngIf="aboUser && aboUser.userAboInfo">
            <h3 class="card-body__title">{{ "abousers.props.highres" | translate }}</h3>
            <div class="row" *ngIf="!aboUser.userAboInfo.highres">
                <div class="col-md-12">-</div>
            </div>

            <div class="row" *ngIf="aboUser.userAboInfo.highres">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "abousers.props.provider" | translate }}</label>
                        <input name="provider" type="text" class="form-control" [ngModel]="aboUser.userAboInfo.highres.provider" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "abousers.props.lastBillingDate" | translate }}</label>
                        <input name="lastBillingDate" type="text" class="form-control" [ngModel]="aboUser.userAboInfo.highres.lastBillingDate | date : UTCDATEFORMAT" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "abousers.props.nextBillingDate" | translate }}</label>
                        <input name="nextBillingDate" type="text" class="form-control" [ngModel]="aboUser.userAboInfo.highres.nextBillingDate | date : UTCDATEFORMAT" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label>{{ "abousers.props.active" | translate }}</label>
                        <div class="row">
                            <div class="col-12">
                                <div class="toggle-switch">
                                    <input type="checkbox" class="toggle-switch__checkbox" [ngModel]="aboUser.userAboInfo.highres.active" id="isHighRes" name="isHighRes" [disabled]="true" />
                                    <i class="toggle-switch__helper"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-4" *ngIf="!aboUser.userAboInfo.highres.active">
                    <div class="form-group">
                        <label>{{ "abousers.props.canceled" | translate }}</label>
                        <input name="canceled" type="text" class="form-control" [ngModel]="aboUser.userAboInfo.highres.canceled | date : UTCDATEFORMAT" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4" *ngIf="!aboUser.userAboInfo.highres.active">
                    <div class="form-group">
                        <label>{{ "abousers.props.cancelReason" | translate }}</label>
                        <textarea name="cancelReason" type="text" class="form-control" [ngModel]="aboUser.userAboInfo.highres.cancelReason" readonly="readonly"></textarea>
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4" *ngIf="!aboUser.userAboInfo.highres.active">
                    <div class="form-group">
                        <label>{{ "abousers.props.highResDeleteDate" | translate }}</label>
                        <input name="highResDeleteDate" type="text" class="form-control" [ngModel]="highResDeleteDate | date : UTCDATEFORMAT" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-4" *ngIf="!aboUser.userAboInfo.highres.active">
                    <div class="form-group">
                        <label>{{ "abousers.props.highResCamResetDate" | translate }}</label>
                        <input name="highResCamResetDate" type="text" class="form-control" [ngModel]="highResCamResetDate | date : UTCDATEFORMAT" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-12" *ngIf="aboUser.userAboInfo.highres.provider === 'google' && aboUser.userAboInfo.highres.lastRealtimeStatus">
                    <div class="form-group">
                        <label>{{ "abousers.props.lastRealtimeStatus" | translate }}</label>
                        <input name="lastRealtimeStatus" type="text" class="form-control" [ngModel]="'abousers.googleRTstatus.' + aboUser.userAboInfo.highres.lastRealtimeStatus | translate" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- quota subscriptions -->
    <div *ngIf="aboUser">
        <div class="card" *ngFor="let quotaAbo of aboUser.userAboInfo?.quota ?? []; let idx = index">
            <div class="card-body">
                <h3 class="card-body__title">
                    {{ "abousers.props.quota" | translate }} {{ idx + 1 }}<span *ngIf="quotaAbo.productId"> ({{ quotaAbo.productId }})</span>:
                </h3>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>{{ "abousers.props.provider" | translate }}</label>
                            <input name="provider_{{ idx }}" type="text" class="form-control" [ngModel]="quotaAbo.provider" readonly="readonly" />
                            <i class="form-group__bar"></i>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="form-group">
                            <label>{{ "abousers.props.lastBillingDate" | translate }}</label>
                            <input name="lastBillingDate_{{ idx }}" type="text" class="form-control" [ngModel]="quotaAbo.lastBillingDate | date : UTCDATEFORMAT" readonly="readonly" />
                            <i class="form-group__bar"></i>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="form-group">
                            <label>{{ "abousers.props.nextBillingDate" | translate }}</label>
                            <input name="nextBillingDate_{{ idx }}" type="text" class="form-control" [ngModel]="quotaAbo.nextBillingDate | date : UTCDATEFORMAT" readonly="readonly" />
                            <i class="form-group__bar"></i>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="form-group">
                            <label>{{ "abousers.props.active" | translate }}</label>
                            <div class="row">
                                <div class="col-12">
                                    <div class="toggle-switch">
                                        <input type="checkbox" class="toggle-switch__checkbox" [ngModel]="quotaAbo.active" id="isHighRes_{{ idx }}" name="isHighRes_{{ idx }}" [disabled]="true" />
                                        <i class="toggle-switch__helper"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4" *ngIf="!quotaAbo.active">
                        <div class="form-group">
                            <label>{{ "abousers.props.canceled" | translate }}</label>
                            <input name="canceled_{{ idx }}" type="text" class="form-control" [ngModel]="quotaAbo.canceled | date : UTCDATEFORMAT" readonly="readonly" />
                            <i class="form-group__bar"></i>
                        </div>
                    </div>

                    <div class="col-md-4" *ngIf="!quotaAbo.active">
                        <div class="form-group">
                            <label>{{ "abousers.props.cancelReason" | translate }}</label>
                            <textarea name="cancelReason_{{ idx }}" type="text" class="form-control" [ngModel]="quotaAbo.cancelReason" readonly="readonly"></textarea>
                            <i class="form-group__bar"></i>
                        </div>
                    </div>

                    <div class="col-md-12" *ngIf="quotaAbo.provider === 'google' && quotaAbo.lastRealtimeStatus">
                        <div class="form-group">
                            <label>{{ "abousers.props.lastRealtimeStatus" | translate }}</label>
                            <input name="lastRealtimeStatus_{{ idx }}" type="text" class="form-control" [ngModel]="'abousers.googleRTstatus.' + quotaAbo.lastRealtimeStatus | translate" readonly="readonly" />
                            <i class="form-group__bar"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- sim card subscriptions -->
    <div class="card">
        <div class="card-body" *ngIf="aboUser && aboUser.userAboInfo">
            <h3 class="card-body__title">{{ "abousers.props.simCardOverview" | translate }}</h3>
            <div class="row">
                <div class="col-md-3">
                    <div class="form-group">
                        <label>{{ "abousers.props.simCardLimit" | translate }}</label>
                        <input name="simCardLimit" type="text" class="form-control" [ngModel]="aboUser.userAboInfo.simCardLimit ?? '-'" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-3">
                    <div class="form-group">
                        <label>{{ "abousers.props.usedSimCardSlots" | translate }}</label>
                        <input name="usedSimCardSlots" type="text" class="form-control" [ngModel]="aboUser.userAboInfo.usedSimCardSlots ?? '-'" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-3">
                    <div class="form-group">
                        <label>{{ "abousers.props.simCardTransferLimitMb" | translate }}</label>
                        <input name="simCardTransferLimitMb" type="text" class="form-control" [ngModel]="aboUser.userAboInfo.simCardTransferLimitMb ?? '-'" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="col-md-3">
                    <div class="form-group">
                        <label>{{ "abousers.props.usedSimCardTransferVolumeMb" | translate }}</label>
                        <input name="usedSimCardTransferVolumeMb" type="text" class="form-control" [ngModel]="aboUser.userAboInfo.usedSimCardTransferVolumeMb ?? '-'" readonly="readonly" />
                        <i class="form-group__bar"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="aboUser">
        <div class="card" *ngFor="let simCardAbo of aboUser.userAboInfo?.simCards ?? []; let idx = index">
            <div class="card-body">
                <h3 class="card-body__title">{{ "abousers.props.simCard" | translate }}:</h3>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>{{ "abousers.props.provider" | translate }}</label>
                            <input name="simCardProvider_{{ idx }}" type="text" class="form-control" [ngModel]="simCardAbo.provider" readonly="readonly" />
                            <i class="form-group__bar"></i>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="form-group">
                            <label>{{ "abousers.props.lastBillingDate" | translate }}</label>
                            <input name="simCardLastBillingDate_{{ idx }}" type="text" class="form-control" [ngModel]="simCardAbo.lastBillingDate | date : UTCDATEFORMAT" readonly="readonly" />
                            <i class="form-group__bar"></i>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="form-group">
                            <label>{{ "abousers.props.nextBillingDate" | translate }}</label>
                            <input name="simCardNextBillingDate_{{ idx }}" type="text" class="form-control" [ngModel]="simCardAbo.nextBillingDate | date : UTCDATEFORMAT" readonly="readonly" />
                            <i class="form-group__bar"></i>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="form-group">
                            <label>{{ "abousers.props.active" | translate }}</label>
                            <div class="row">
                                <div class="col-12">
                                    <div class="toggle-switch">
                                        <input type="checkbox" class="toggle-switch__checkbox" [ngModel]="simCardAbo.active" id="simCardActive_{{ idx }}" name="simCardActive_{{ idx }}" [disabled]="true" />
                                        <i class="toggle-switch__helper"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4" *ngIf="!simCardAbo.active">
                        <div class="form-group">
                            <label>{{ "abousers.props.canceled" | translate }}</label>
                            <input name="simCardCanceled_{{ idx }}" type="text" class="form-control" [ngModel]="simCardAbo.canceled | date : UTCDATEFORMAT" readonly="readonly" />
                            <i class="form-group__bar"></i>
                        </div>
                    </div>

                    <div class="col-md-4" *ngIf="!simCardAbo.active">
                        <div class="form-group">
                            <label>{{ "abousers.props.cancelReason" | translate }}</label>
                            <textarea name="simCardCancelReason_{{ idx }}" type="text" class="form-control" [ngModel]="simCardAbo.cancelReason" readonly="readonly"></textarea>
                            <i class="form-group__bar"></i>
                        </div>
                    </div>

                    <div class="col-md-12" *ngIf="simCardAbo.provider === 'google' && simCardAbo.lastRealtimeStatus">
                        <div class="form-group">
                            <label>{{ "abousers.props.lastRealtimeStatus" | translate }}</label>
                            <input name="simCardLastRealtimeStatus_{{ idx }}" type="text" class="form-control" [ngModel]="'abousers.googleRTstatus.' + simCardAbo.lastRealtimeStatus | translate" readonly="readonly" />
                            <i class="form-group__bar"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
